import { observer } from "mobx-react-lite";
import { useState } from "react";
import { Button, message } from "antd";
import { globalModel } from "../../global/GlobalModel";
import { membershipRetailPurchaseState } from "../../products/membership/membershipPurchaseUtils";
import { membershipNoRetailPurchaseHint } from "../../platform_spaces/space/spacePageUtils";
import type { MembershipProduct } from "../../platform_spaces/space/SpaceType";
import { BundlePlanPurchaseActions } from "../../platform_spaces/space/components/BundlePlanPurchaseActions";
import { StandaloneProductPurchaseModal } from "../purchase/StandaloneProductPurchaseModal";

type Props = {
  row: MembershipProduct;
  spaceId: string;
  membershipProducts: MembershipProduct[];
};

/** 独立站产品页：海报上的订阅按钮 + 购买弹窗 */
export const StandaloneProductSubscribeCta = observer((props: Props) => {
  const { row, spaceId, membershipProducts } = props;
  const [purchaseOpen, setPurchaseOpen] = useState(false);
  const { canBuyRetail } = membershipRetailPurchaseState(row);

  const openPurchaseModal = () => {
    if (!globalModel.isLoggedIn) {
      globalModel.openLoginModal();
      return;
    }
    if (row.purchaseBlocked) {
      message.info(membershipNoRetailPurchaseHint(row));
      return;
    }
    if (!canBuyRetail) {
      message.info(membershipNoRetailPurchaseHint(row));
      return;
    }
    setPurchaseOpen(true);
  };

  return (
    <>
      <div className="space-poster-subscribe-actions">
        <BundlePlanPurchaseActions
          spaceId={spaceId}
          row={row}
          membershipProducts={membershipProducts}
          isLoggedIn={globalModel.isLoggedIn}
          onLoginRequest={() => globalModel.openLoginModal()}
          spaceProfile={null}
          variant="standalone"
        />
        {canBuyRetail ? (
          <Button
            type="primary"
            className="space-access-gate__subscribe-btn"
            onClick={openPurchaseModal}
          >
            订阅
          </Button>
        ) : (
          <span className="space-m-no-spec-hint">
            {membershipNoRetailPurchaseHint(row)}
          </span>
        )}
      </div>
      <StandaloneProductPurchaseModal
        row={row}
        open={purchaseOpen}
        onClose={() => setPurchaseOpen(false)}
        isLoggedIn={globalModel.isLoggedIn}
        onLoginRequest={() => globalModel.openLoginModal()}
      />
    </>
  );
});
